import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import './Team.css';
import { Heading, TeamItem } from '../../../components';
import { team } from '../../../constants';
import { useTranslation } from 'react-i18next';

const Team = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className='team'>
      <Heading title={t('teamSection.headingTitle')} subTitle={t('teamSection.subTitle')} />

      {/* Dodany wstęp tekstowy */}
      <div className="team-intro">
        <p>{t('teamSection.intro.paragraph1')}</p>
        <p>{t('teamSection.intro.paragraph2')}</p>
        <p>{t('teamSection.intro.paragraph3')}</p>
        <p className="team-signature">
          {t('teamSection.signature.line1')}<br />
          <strong>{t('teamSection.signature.name')}</strong>
        </p>
      </div>

      <div className='box-container'>
        {team.map((item) => (
          <TeamItem 
            key={item.id}
            image={item.image}
            name={item.name}
            title={t(item.titleKey)} /* Użycie klucza zamiast item.title */
            accounts={item.accounts}
            team={item}
          /> 
        ))}
      </div>

      {/* Kontener na guzik */}
      <div className="team-footer">
        <button className="gallery-btn-green" onClick={() => navigate('/RadaNaukowa/Galeria')}>
          {t('teamSection.galleryButton')}
        </button>
      </div>

    </section>
  );
}

export default Team;